<template>
  <Card class="mb-4">
    <template #header>
      <h2 class="mb-0" @click="toggleFahrerkreis()">Fahrerkreis</h2>
    </template>

    <div>
        <b-row>

<b-col md="6">
  <h4>Alter jüngster Nutzer</h4>
  <base-input
    prepend-icon="fas fa-calendar"
    v-model="offer.softfair_alter_juengster_nutzer"
    type="date"
    name="Alter jüngster Nutzer"
    rules="required"
    placeholder="DD.MM.YYYY"
  >
  </base-input>
</b-col>

<b-col md="6">
  <h4>Alter ältester Nutzer</h4>
  <base-input
    prepend-icon="fas fa-calendar"
    v-model="offer.softfair_alter_aeltester_nutzer"
    type="date"
    name="Alter ältester Nutzer"
    rules="required"
    placeholder="DD.MM.YYYY"
  >
  </base-input>
</b-col>


</b-row>
      </div>

      <b-row>
        <b-col lg="6">
          <h4 @click="toggleOptional()">Optional</h4>
        </b-col>
        <b-col lg="6" class="text-right">
          <i v-if="show_optional" class="fa fa-chevron-down" @click="toggleOptional()"></i>
          <i v-else class="fa fa-chevron-left" @click="toggleOptional()"></i>
        </b-col>
      </b-row>

    <div v-if="show_optional">

      <div>
        <h4>VN ist Fahrer</h4>
        <div class="d-flex">
          <div class="mr-4">
            <input type="radio" id="kaskotyp_ohne" value="Ohne" v-model="offer.softfair_vn_ist_fahrer" class="mr-2" />
            <label for="kaskotyp_ohne">Ja</label>
          </div>
          <div class="mr-4">
            <input type="radio" id="kaskotyp_teilkasko" value="Teilkasko" v-model="offer.softfair_vn_ist_fahrer"
              class="mr-2" />
            <label for="kaskotyp_teilkasko">Nein</label>
          </div>
        </div>
      </div>

      <div>
        <h4>VN ist Hauptnutzer</h4>
        <div class="d-flex">
          <div class="mr-4">
            <input type="radio" id="kaskotyp_ohne" value="Ohne" v-model="offer.softfair_vn_ist_hauptnutzer" class="mr-2" />
            <label for="kaskotyp_ohne">Ja</label>
          </div>
          <div class="mr-4">
            <input type="radio" id="kaskotyp_teilkasko" value="Teilkasko" v-model="offer.softfair_vn_ist_hauptnutzer"
              class="mr-2" />
            <label for="kaskotyp_teilkasko">Nein</label>
          </div>
        </div>
      </div>

      <div>
        <h4>Fahrerkreis Typ</h4>
        <div class="d-flex">
          <div class="mr-4">
            <input type="radio" id="kaskotyp_ohne" value="Ohne" v-model="offer.softfair_fahrerkreis_typ" class="mr-2" />
            <label for="kaskotyp_ohne">Offen</label>
          </div>
          <div class="mr-4">
            <input type="radio" id="kaskotyp_teilkasko" value="Teilkasko" v-model="offer.softfair_fahrerkreis_typ"
              class="mr-2" />
            <label for="kaskotyp_teilkasko">Eingeschränkt</label>
          </div>
        </div>
      </div>


          <!-- Nutzerliste (Tags) -->
    <div>
      <label>Nutzerliste</label>
      <TagsInput v-model="nutzerliste" />
    </div>




    </div>


  </Card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BaseSelect from '@/components/Inputs/BaseSelect.vue';
import TagsInput from '@/components/Inputs/TagsInput.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import Card from '@/components/Cards/Card.vue';

export default {
  name: "soft-fair-fahrerkreis",
  components: {
    BaseSelect,
    TagsInput,
    BaseInput,
    Card,
  },
  data() {
    return {
      loading: false,
      options: [],

      vnIstFahrer: "Ja",
      vnIstHauptnutzer: "Ja",
      fahrerkreisTyp: "Offen",
      nutzerliste: [],

      show_optional: false,
    };
  },
  methods: {
    toggleOptional() {
      this.show_optional = !this.show_optional;
    },
    financial(x) {
      if (isNaN(Number.parseFloat(x).toFixed(2))) {
        return 0;
      }
      return Number.parseFloat(x).toFixed(2);
    },
  },
  computed: {
    ...mapGetters({
      currentAccount: "currentAccount",
    }),
    ...mapState({
      account: state => state.account,
      offer: (state) => state.softfairOffer,
    }),
  },
  mounted() {
  },
};
</script>
<style></style>